import React from 'react'
import { BsFillPersonLinesFill } from 'react-icons/bs'
import { IoIosLogOut } from 'react-icons/io'
import { RiDeviceRecoverLine } from 'react-icons/ri'
import { TbFileReport } from 'react-icons/tb'
import { FiUserPlus } from 'react-icons/fi'
import { MdOutlineDashboard } from 'react-icons/md'
import { RiUserLocationLine, RiFileHistoryLine } from 'react-icons/ri'

export const SidebarData = [
  {
    title: 'Dashboard',
    path: '/home',
    icon: <MdOutlineDashboard />,
    cName: 'nav-text',
  },
  // {
  //   title: 'Referral Applications',
  //   path: '/referral',
  //   icon: <MdGroupAdd />,
  //   cName: 'nav-text',
  // },
  {
    title: 'Deleted Users',
    path: '/recoverapplications',
    icon: <RiDeviceRecoverLine />,
    cName: 'nav-text',
  },
  {
    title: 'Reports',
    path: '/findApplications',
    icon: <TbFileReport />,
    cName: 'nav-text',
  },
  {
    title: 'Users',
    path: '/userList',
    icon: <BsFillPersonLinesFill />,
    cName: 'nav-text',
  },
  {
    title: 'Add Candidate',
    path: '/addCandidate',
    icon: <FiUserPlus />,
    cName: 'nav-text',
  },
  {
    title: 'Position Add/View',
    path: '/position-mgmt',
    icon: <RiUserLocationLine />,
    cName: 'nav-text',
  },
  {
    title: 'Interview History',
    path: '/interviewHistory',
    icon: <RiFileHistoryLine />,
    cName: 'nav-text',
    id: 'historynav',
  },
  {
    title: 'Logout',
    path: '',
    icon: <IoIosLogOut />,
    cName: 'nav-text',
  },
]
